import Chip from '@mui/material/Chip';
import DefaultTooltip from '../../Tooltips/DefaultTooltip';

import {
  AgGridColumnView,
  PricingBasis,
} from '../../../../../shared/types';
import { roundToTwoDecimal } from '../../../../../shared/roundToTwoDecimal';

const toolTipText =
  'Hintakertoimien keskiarvot: Syötetyt hinnat | Painotettu vuokrahistorialla | Ehdotushinnat';

type SingleChipProps = {
  meanFilledCoefficient: number;
  meanFilledCoefficientWeight: number;
  meanProposalCoefficient: number;
};

const SingleChip = ({
  meanFilledCoefficient,
  meanFilledCoefficientWeight,
  meanProposalCoefficient,
}: SingleChipProps) => {
  return (
    <Chip
      size="small"
      sx={{ ml: 1, backgroundColor: 'white', fontSize: 13 }}
      label={`S: ${roundToTwoDecimal(meanFilledCoefficient)} | P: ${
        isNaN(roundToTwoDecimal(meanFilledCoefficientWeight))
          ? '-'
          : roundToTwoDecimal(meanFilledCoefficientWeight)
      } | E: ${roundToTwoDecimal(meanProposalCoefficient)}
`}
      variant="outlined"
    />
  );
};

type CoefficientChipsProps = {
  means: {
    meanFilledDay: number | null;
    meanFilledDayWeight: number | null;
    meanProposalDay: number | null;
    meanFilledMonth: number | null;
    meanProposalMonth: number | null;
    meanFilledMonthWeight: number | null;
  };
  pricingBasis: PricingBasis;
  gridColumnView: AgGridColumnView;
};

const CoefficientChips = ({
  means,
  pricingBasis,
  gridColumnView,
}: CoefficientChipsProps) => {
  return (
    <>
      <DefaultTooltip placement="right" title={toolTipText}>
        <span>
          {means.meanFilledDay &&
          means.meanProposalDay &&
          (pricingBasis === 'DAY' || pricingBasis === 'BOTH') &&
          (gridColumnView === AgGridColumnView.PRICING_DAY ||
            gridColumnView === AgGridColumnView.PRICING_BOTH ||
            gridColumnView === AgGridColumnView.INSPECT_DAY ||
            gridColumnView === AgGridColumnView.INSPECT_BOTH ||
            gridColumnView === AgGridColumnView.OFFER_PRICING) ? (
            <SingleChip
              meanFilledCoefficient={means.meanFilledDay}
              meanFilledCoefficientWeight={
                means.meanFilledDayWeight ?? 0
              }
              meanProposalCoefficient={means.meanProposalDay}
            />
          ) : null}
          {means.meanFilledMonth &&
          means.meanProposalMonth &&
          (pricingBasis === 'BOTH' || pricingBasis === 'MONTH') &&
          (gridColumnView === AgGridColumnView.PRICING_MONTH ||
            gridColumnView === AgGridColumnView.PRICING_BOTH ||
            gridColumnView === AgGridColumnView.INSPECT_BOTH ||
            gridColumnView === AgGridColumnView.OFFER_PRICING) ? (
            <SingleChip
              meanFilledCoefficient={means.meanFilledMonth}
              meanFilledCoefficientWeight={
                means.meanFilledMonthWeight ?? 0
              }
              meanProposalCoefficient={means.meanProposalMonth}
            />
          ) : null}
        </span>
      </DefaultTooltip>
    </>
  );
};

export default CoefficientChips;
